import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ClaimType')
export class ClaimType {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('claim_type', String, true)
    claimType = '';

    @JsonProperty('claim_type_ar', String, true)
    claimTypeAr = '';

    get typeStr() {
        return this.claimType || this.claimTypeAr;
    }
}